module.exports = __webpack_public_path__ + "static/media/beefyfinance.bd550431.png";